import * as React from 'react';
import { Body2 } from '@cian/ui-kit';

import { ITextListCell } from '../../../../../../types/newbuildingsCompare';

export interface ITextListCellProps {
  cell: ITextListCell;
}

export const TextListCell = ({ cell }: ITextListCellProps): React.JSX.Element => (
  <Body2>{cell.data?.items.join(', ') ?? cell.state.text ?? ''}</Body2>
);
